export enum Steps {
  PATH = "path",
  STEP1 = "step1",
  STEP2 = "step2",
  STEP3 = "step3",
  STEP4 = "step4",
  STEP5 = "step5",
  STEP6 = "step6",
  STEP_BLOGPAY = "blogpay",
}
